import { useRef, useState } from "react";
import {
  SevenColGrid,
  Wrapper,
  DateControls,
  StyledEvent,
  SeeMore,
  PortalWrapper,
} from "./Calender.styled";
import { DAYS, MOCKAPPS } from "./Cont";
import {
  datesAreOnSameDay,
  getDarkColor,
  getDaysInMonth,
  getMonthYear,
  getSortedDays,
  nextMonth,
  prevMonth,
  range,
  sortDays,
} from "./Utils";
import colors from "../../config/colors";
import styled from "styled-components";
import moment from "moment";
import EventRecord from "./EventRecord";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
const HeadDays = styled.div`
  && {
    background-color: ${colors.primary};
    color: white;
    padding: 2px;
  }
  /* other styles */
`;

export const Calender = ({ keyss, advertiser, handleDateClick, type,eventRecords:events,eventdata ,vehiclesid,onEventSubmit,fetchevent}) => {
  console.log(advertiser);
 
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selctedDate, setSelctedDate] = useState(new Date());
  const [events2, setEvents] = useState();
  
  const dragDateRef = useRef();
  const dragindexRef = useRef();
  const [showPortal, setShowPortal] = useState(false);
  const [portalData, setPortalData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const[eventid,seteventid]=useState()

  const addEvent = (date, event) => {
    if (!event.target.classList.contains("StyledEvent")) {
      
      setSelctedDate(date);
      setModalShow(true);
    }
  };
  const vehicles =()=>{
  toast.error("Select Vehicle")
  }
  

  const drag = (index, e) => {
    dragindexRef.current = { index, target: e.target };
  };
 console.log(events,"kjkjkjkjkjkjkj");
  const onDragEnter = (date, e) => {
    e.preventDefault();
    dragDateRef.current = { date, target: e.target.id };
  };

  const drop = (ev) => {
    ev.preventDefault();

    setEvents((prev) =>
      prev.map((ev, index) => {
        if (index === dragindexRef.current.index) {
          ev.date = dragDateRef.current.date;
        }
        return ev;
      })
    );
  };

  const handleOnClickEvent = (event, day) => {
    console.log(event,'qyqyyq')
    setShowPortal(true);
    seteventid(event)
    setPortalData(event);
 

  };
  console.log(eventid ,'hjkhk')
  const handlePotalClose = () => setShowPortal(false);

//   const handleDelete = async () => {

//     const res = await apiClient.delete(`${eventid}/`);


// console.log(res)
    
//     handlePotalClose();
//   };
const handleDelete = async (id) => {
 
    console.log(id,'swuwsuwuuwujkhk')
    const res = await apiClient.delete(`/schedule/events/${id}/`);
    
 
    fetchevent()
    handlePotalClose();
   if(res.ok){
    return   toast.success(" Event Deleted");
   }else
    toast.error("Error deleting event:");
 

};

  return (
    <>
      <Wrapper
      style={{overflow:"auto"}}>
        <DateControls>
          <ion-icon
            onClick={() => prevMonth(currentDate, setCurrentDate)}
            name="arrow-back-circle-outline"
          ></ion-icon>
          {getMonthYear(currentDate)}
          <ion-icon
            onClick={() => nextMonth(currentDate, setCurrentDate)}
            name="arrow-forward-circle-outline"
          ></ion-icon>
        </DateControls>
        <SevenColGrid style={{ backgroundColor: colors.primary }}>
          {DAYS.map((day) => (
            <HeadDays className="nonDRAG" style={{minWidth:'50px'}}>{day}</HeadDays>
          ))}
        </SevenColGrid>

        <SevenColGrid
        
          fullheight={true}
          is28Days={getDaysInMonth(currentDate) === 28}
        >
          {getSortedDays(currentDate).map((day) => (
            <div
            style={{minWidth:50}}
              id={`${currentDate.getFullYear()}/${currentDate.getMonth()}/${day}`}
              onDragEnter={(e) =>
                onDragEnter(
                  new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    day
                  ),
                  e
                )
              }
              onDragOver={(e) => e.preventDefault()}
              onDragEnd={drop}
              onClick={(e) => {
                let events2 = [];
                for (const item of events) {
                  if (
                    datesAreOnSameDay(
                      item.date,
                      new Date(
                        currentDate.getFullYear(),
                        currentDate.getMonth(),
                        day
                      )
                    )
                  )
                    events2.push(item);
                }
                setSelctedDate(
                  new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    day
                  )
                );
                handleDateClick(
                  moment(
                    new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      day
                    )
                  ).format("D-MMM-YYYY"),
                  events2
                );
              }}
            >
              <span className="d-flex p-1 h-25 pb-0 justify-content-between">
                {!advertiser && (
vehiclesid?

 <i 
                  
                  onClick={(e) =>
                    addEvent(
                      new Date(
                        currentDate.getFullYear(),
                        currentDate.getMonth(),
                        day
                      ),
                      e
                    )
                  }
                  class="bi bi-plus-square-fill"
                >

                </i>: <i 
                  
                  onClick={(e) =>
                    vehicles(
                     
                    )
                  }
                  class="bi bi-plus-square-fill"
                >

                </i>
              
                 
                )}
                {/* <i
                  onClick={(e) =>
                    addEvent(
                      new Date(
                        currentDate.getFullYear(),
                        currentDate.getMonth(),
                        day
                      ),
                      e
                    )
                  }
                  class="bi bi-plus-square-fill"
                ></i> */}
                <span
                  className={`nonDRAG ${
                    datesAreOnSameDay(
                      new Date(),
                      new Date(
                        currentDate.getFullYear(),
                        currentDate.getMonth(),
                        day
                      )
                    )
                      ? "active"
                      : ""
                  }`}
                >
                  {day}
                </span>
              </span>

              <span className="d-flex justify-content-center  ">
                <span style={{ width: "75%" }}>
                  <EventWrapper
                    date={day}
                    events={events}
                    onEventShow={handleDateClick}
                  >
                    {events.map(
                      
                      (ev, index) =>
                        datesAreOnSameDay(
                         new Date( ev.date),
                          new Date(
                            currentDate.getFullYear(),
                            currentDate.getMonth(),
                            day
                          )
                        ) && 
                        (
                          <StyledEvent
                            onDragStart={(e) => drag(index, e)}
                            onClick={() => handleOnClickEvent(ev, day)}
                            // draggable
                            className="StyledEvent mb-1"
                            id={`${ev.color} ${ev.title}`}
                            key={ev.title}
                            bgColor={"black"}
                          >
                            {ev?.event_type?.request_type}
                            <img src={ev?.event_type?.event_type} alt="" />
                          </StyledEvent>
                        ) 
                    )}
                    
                  </EventWrapper>
                </span>
              </span>
            </div>
          ))}
        </SevenColGrid>
        {showPortal && (
          <Portal
            {...portalData}
            handleDelete={handleDelete}
            handlePotalClose={handlePotalClose}
            eventid={eventid}
            

          />
        )}
      </Wrapper>
      {modalShow && (
        <EventRecord
        onEventSubmit={onEventSubmit}
        vehiclesid={vehiclesid}
        eventdata={eventdata}
        fetchevent  
          values={{

            keyss,
            show: modalShow,
            type,
            selctedDate,
            setEvents,
            events,
            getDarkColor,
            onHide: () => setModalShow(false),
          
            
          }}
        />
      )}
    </>
  );
};

const EventWrapper = ({ children, }) => {
  if (children.filter((child) => child).length)
    return (
      <>
        {children}
        {children.filter((child) => child).length > 2 && (
          <SeeMore>see more...</SeeMore>
        )}
      </>
    );
};

const Portal = ({ title, date, handleDelete, handlePotalClose,eventid }) => {


  return (
    <PortalWrapper>
      <div className="d-flex align-items-center">

      <h2 className="me-2">{eventid?.event_type?.request_type }</h2>
      <img height={"30px"} src={eventid?.event_type.icon_url} alt="" />
      </div>

      <p>{eventid.date}</p>
     
      <ion-icon onClick={()=>handleDelete(eventid.id)} name="trash-outline"></ion-icon>
      <ion-icon onClick={handlePotalClose} name="close-outline"></ion-icon>
    </PortalWrapper>
  );
};
